import { PriceListItemType } from '../../api/interfaces/priceListItemType';
import { RelationSelectItem } from '../../components';

export const priceListItemTypeAsSelectOptions = [
    { text: 'Za lůžko/noc', value: PriceListItemType.PerBedAndNight } as RelationSelectItem,
    { text: 'Za pokoj/noc', value: PriceListItemType.PerRoomAndNight } as RelationSelectItem,
    { text: 'Za poplatek', value: PriceListItemType.Fee } as RelationSelectItem
];
